import React from 'react';
import {useParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import {routeRegistry} from 'src/pages/RouteRegistry';
import type {AssetsViewType} from 'src/shared/constants/ViewTypes';
import {AssetsForm} from 'src/pages/Modules/Assets/shared/AssetForm/AssetForm';
import {AssetsBrowserShell} from 'src/app/assets/AssetsBrowserShell';
import {toAssetTreeNodeId} from 'src/app/assets/assetTreeBrowserState';
import {assetDocumentTitle} from 'src/pages/Modules/Assets/assetHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

const CreateAssetPage: React.FC = () => {
  useSetDocumentTitle(assetDocumentTitle);
  const {parentId, view} = useParams();
  const nParentId = parentId && parentId !== 'root' ? +parentId : undefined;

  return (
    <AssetsBrowserShell selectedId={toAssetTreeNodeId(nParentId)}>
      <AssetsForm
        mode="create"
        parentId={nParentId}
        view={view as AssetsViewType}
      />
    </AssetsBrowserShell>
  );
};

export default CreateAssetPage;

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.AssetCreate(':parentId'),
  element: <CreateAssetPage />,
  module: ModuleEnum.Assets,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
